<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true
			v-model="isFilterShow" :dialog-class="''" :ok-title="'Search'" ok-variant="success" :cancel-title="'Clear'"
			@ok="getControlCards" @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-control-card-number" label-cols-sm="4" label-cols-lg="3"
							label="Control Card Number" label-for="filter-control-card-number" size="sm"
							:model.sync="filter.controlCardNumber" />
						<app-input-combobox-autocomplete :options="controlCardTypes" optionsLabel="code" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Control Card Type" id="filter-" size="sm"
							:model.sync="filter.controlCardTypeId" @input="getControlCardTypes"
							@focus="getControlCardTypes" />
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Part" id="filter-" size="sm"
							:model.sync="filter.partId" @input="getParts" @focus="getParts" />
						<app-input-combobox-autocomplete :options="partClassifications" optionsLabel="code" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Part Classification" id="filter-" size="sm"
							:model.sync="filter.partClassificationId" @input="getPartClassifications" @focus="getPartClassifications" />
						<app-input-textbox id="fieldset-qty-case" label-cols-sm="4" label-cols-lg="3" label="Qty Case"
							label-for="filter-qty-case" size="sm" :model.sync="filter.qtyCaseFrom" />
						<app-input-textbox id="fieldset-qty-case" label-cols-sm="4" label-cols-lg="3"
							label-for="filter-qty-case" size="sm" :model.sync="filter.qtyCaseTo" />
						<app-input-combobox-autocomplete :options="areas" optionsLabel="code" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Area" id="filter-" size="sm"
							:model.sync="filter.areaId" @input="getAreas" @focus="getAreas" />
						<app-input-combobox-autocomplete :options="racks" optionsLabel="code" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Rack" id="filter-" size="sm"
							:model.sync="filter.rackId" @input="getRacks" @focus="getRacks" />
						<app-input-combobox-autocomplete :options="vendors" optionsLabel="name" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Vendor" id="filter-" size="sm"
							:model.sync="filter.vendorSubcontId" @input="getVendors" @focus="getVendors" />
						<!-- <app-input-textbox id="fieldset-doc-no" label-cols-sm="4" label-cols-lg="3" label="DocNo"
							label-for="filter-doc-no" size="sm" :model.sync="filter.docNo" /> -->
						<app-input-textbox id="fieldset-status" label-cols-sm="4" label-cols-lg="3" label="Status"
							label-for="filter-status" size="sm" :model.sync="filter.status" />
						<app-input-combobox-autocomplete :options="qcStatuss" optionsLabel="name" optionsKey="id" 
							label-cols-sm="4" label-cols-lg="3" label="Qc Status" id="filter-" size="sm" 
							:model.sync="filter.qcStatusId" @input="getQcStatuss" @focus="getQcStatuss" />
					</b-col>
					<b-col cols="12" lg="6">
						<app-input-datetimepicker-range id="fieldset-receiving-date" label-cols-sm="4" label-cols-lg="3"
							label="Receiving Date" size="sm" :modelFrom.sync="filter.receivingDateFrom"
							:modelTo.sync="filter.receivingDateTo"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							reset-button />
						<app-input-datetimepicker-range id="fieldset-delivery-date" label-cols-sm="4" label-cols-lg="3"
							label="Delivery Date" size="sm" :modelFrom.sync="filter.deliveryDateFrom"
							:modelTo.sync="filter.deliveryDateTo"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							reset-button />
						<app-input-textbox id="fieldset-transaction-type" label-cols-sm="4" label-cols-lg="3"
							label="Transaction Type" label-for="filter-transaction-type" size="sm"
							:model.sync="filter.transactionType" />
						<app-input-textbox id="fieldset-transaction-id" label-cols-sm="4" label-cols-lg="3"
							label="Transaction Id" label-for="filter-transaction-id" size="sm"
							:model.sync="filter.transactionId" />
						<app-input-textbox id="fieldset-revisi" label-cols-sm="4" label-cols-lg="3" label="Revisi"
							label-for="filter-revisi" size="sm" :model.sync="filter.revisi" />
						<app-input-textbox id="fieldset-pack-sequence" label-cols-sm="4" label-cols-lg="3"
							label="Pack Sequence" label-for="filter-pack-sequence" size="sm"
							:model.sync="filter.packSequence" />
						<app-input-textbox id="fieldset-total-pack" label-cols-sm="4" label-cols-lg="3" label="Total Pack"
							label-for="filter-total-pack" size="sm" :model.sync="filter.totalPackFrom" />
						<app-input-textbox id="fieldset-total-pack" label-cols-sm="4" label-cols-lg="3"
							label-for="filter-total-pack" size="sm" :model.sync="filter.totalPackTo" />
						<app-input-combobox-autocomplete :options="controlCardStatuss" optionsLabel="name" optionsKey="id"
							label-cols-sm="4" label-cols-lg="3" label="Control Card Status" id="filter-" size="sm"
							:model.sync="filter.controlCardStatusId" @input="getControlCardStatuss"
							@focus="getControlCardStatuss" />
						<app-input-combobox-autocomplete :options="originalControlCardNumbers" optionsLabel="controlCardNumber" optionsKey="id" 
							label-cols-sm="4" label-cols-lg="3" label="Original Control Card" id="filter-" size="sm" 
							:model.sync="filter.originalControlCardId" @input="getOriginalControlCards" @focus="getOriginalControlCards" />
						
						<app-input-datetimepicker-range id="fieldset-created-date" label-cols-sm="4" label-cols-lg="3"
							label="Created Date" size="sm" :modelFrom.sync="filter.createdDateFrom"
							:modelTo.sync="filter.createdDateTo"
							:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
							reset-button />


						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span
								style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1"
							@click="getControlCards"><span style="font-size: 0.75rem"
								class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading" rounded opacity="0.6" spinner-small spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Control Card</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<b-dropdown v-if="true" text="Action" class="m-md-2 btn-action-more" size="sm">
							<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="files/controlcard/ControlCard.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="false" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<!-- <b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay> -->

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<!-- <span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span> -->
					<b-button class="btn-action" size="sm" @click="printCard"><b-icon-printer class="mr-1"></b-icon-printer> Print Control Card</b-button>
				</div> 
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-controlcard"
					:class="'table-action sticky-head-color' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true"
					:no-local-sorting="true" :items="controlCards" :fields="fields" :busy="isDataLoading"
					:sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty
					:tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="controlCards.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm"
							class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
						<b-th></b-th>
						<b-th stacked-heading="Control Card Number" class="table-filter">
							<b-form-input id="input-control-card-number-table" @input="getControlCardsWithoutLoading"
								v-model="filter.controlCardNumber" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Control Card Type" class="table-filter">
							<v-select append-to-body label="code" :options="controlCardTypes"
								:value="filter.controlCardTypeId" :reduce="item => item.id"
								v-model="filter.controlCardTypeId" :filterable="true" @input="getControlCardsWithoutLoading"
								@search="getControlCardTypes"></v-select>
						</b-th>
						<b-th stacked-heading="Part" class="table-filter">
							<v-select append-to-body label="partNumber" :options="parts" :value="filter.partId"
								:reduce="item => item.id" v-model="filter.partId" :filterable="true"
								@input="getControlCardsWithoutLoading" @search="getParts"></v-select>
						</b-th>
						<b-th stacked-heading="Part Classification" class="table-filter">
							<v-select append-to-body label="code" :options="partClassifications" :value="filter.partClassificationId"
								:reduce="item => item.id" v-model="filter.partClassificationId" :filterable="true"
								@input="getControlCardsWithoutLoading" @search="getPartClassifications" />
						</b-th>
						<b-th stacked-heading="Qty Case" class="table-filter">
							<b-form-input id="input-qty-case-table" @input="getControlCardsWithoutLoading"
								v-model="filter.qtyCaseFrom" size="sm"></b-form-input>
							<b-form-input id="input-qty-case-table" @input="getControlCardsWithoutLoading"
								v-model="filter.qtyCaseTo" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Area" class="table-filter">
							<v-select append-to-body label="code" :options="areas" :value="filter.areaId"
								:reduce="item => item.id" v-model="filter.areaId" :filterable="true"
								@input="getControlCardsWithoutLoading" @search="getAreas"></v-select>
						</b-th>
						<b-th stacked-heading="Rack" class="table-filter">
							<v-select append-to-body label="code" :options="racks" :value="filter.rackId"
								:reduce="item => item.id" v-model="filter.rackId" :filterable="true"
								@input="getControlCardsWithoutLoading" @search="getRacks"></v-select>
						</b-th>
						<b-th stacked-heading="Vendor" class="table-filter">
							<v-select append-to-body label="name" :options="vendors" :value="filter.vendorSubcontId"
								:reduce="item => item.id" v-model="filter.vendorSubcontId" :filterable="true"
								@input="getControlCardsWithoutLoading" @search="getVendors"></v-select>
						</b-th>
						<!-- <b-th stacked-heading="DocNo" class="table-filter">
							<b-form-input id="input-doc-no-table" @input="getControlCardsWithoutLoading"
								v-model="filter.docNo" size="sm"></b-form-input>
						</b-th> -->
						<b-th stacked-heading="Status" class="table-filter">
							<b-form-input id="input-status-table" @input="getControlCardsWithoutLoading"
								v-model="filter.status" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Receiving Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-receiving-date" label-cols-sm="4" label-cols-lg="3"
								:nolabel="true" label="Receiving Date" size="sm" :modelFrom.sync="filter.receivingDateFrom"
								:modelTo.sync="filter.receivingDateTo"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
								reset-button @change="getControlCardsWithoutLoading" />
						</b-th>
						<b-th stacked-heading="Delivery Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-delivery-date" label-cols-sm="4" label-cols-lg="3"
								:nolabel="true" label="Delivery Date" size="sm" :modelFrom.sync="filter.deliveryDateFrom"
								:modelTo.sync="filter.deliveryDateTo"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
								reset-button @change="getControlCardsWithoutLoading" />
						</b-th>
						<b-th stacked-heading="Transaction Type" class="table-filter">
							<b-form-input id="input-transaction-type-table" @input="getControlCardsWithoutLoading"
								v-model="filter.transactionType" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Transaction Id" class="table-filter">
							<b-form-input id="input-transaction-id-table" @input="getControlCardsWithoutLoading"
								v-model="filter.transactionId" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Revisi" class="table-filter">
							<b-form-input id="input-revisi-table" @input="getControlCardsWithoutLoading"
								v-model="filter.revisi" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Pack Sequence" class="table-filter">
							<b-form-input id="input-pack-sequence-table" @input="getControlCardsWithoutLoading"
								v-model="filter.packSequence" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Total Pack" class="table-filter">
							<b-form-input id="input-total-pack-table" @input="getControlCardsWithoutLoading"
								v-model="filter.totalPackFrom" size="sm"></b-form-input>
							<b-form-input id="input-total-pack-table" @input="getControlCardsWithoutLoading"
								v-model="filter.totalPackTo" size="sm"></b-form-input>
						</b-th>
						<b-th stacked-heading="Control Card Status" class="table-filter">
							<v-select append-to-body label="name" :options="controlCardStatuss"
								:value="filter.controlCardStatusId" :reduce="item => item.id"
								v-model="filter.controlCardStatusId" :filterable="true"
								@input="getControlCardsWithoutLoading" @search="getControlCardStatuss"></v-select>
						</b-th>
						<b-th stacked-heading="Qc Status" class="table-filter">
							<v-select append-to-body label="name" :options="qcStatuss" 
								:value="filter.qcStatusId" :reduce="item => item.id" 
								v-model="filter.qcStatusId" :filterable="true" 
								@input="getControlCardsWithoutLoading" @search="getQcStatuss"></v-select>
						</b-th>
						<b-th stacked-heading="Original Control Card" class="table-filter">
							<v-select append-to-body label="controlCardNumber" :options="originalControlCardNumbers" 
								:value="filter.originalControlCardId" :reduce="item => item.id" 
								v-model="filter.originalControlCardId" :filterable="true" 
								@input="getControlCardsWithoutLoading" @search="getOriginalControlCards"></v-select>
						</b-th>
						<b-th stacked-heading="Created Date" class="table-filter">
							<app-input-datetimepicker-range id="fieldset-created-date" label-cols-sm="4" label-cols-lg="3"
								:nolabel="true" label="Created Date" size="sm" :modelFrom.sync="filter.createdDateFrom"
								:modelTo.sync="filter.createdDateTo"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
								reset-button @change="getControlCardsWithoutLoading" />
						</b-th>
						<!-- <b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all"
								class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th> -->
					</template>

					<template v-slot:head(checkboxAction)>
						<div class="d-flex justify-content-center ml-2" v-if="true">
							<b-form-checkbox id="input-is-checked-all" @change="toggleSelectAll" :checked="checkAll"></b-form-checkbox>
						</div>
					</template>

					<template v-slot:cell(checkboxAction)="row">
						<div class="d-flex justify-content-center ml-2" v-if="true">
							<b-form-checkbox :key="row.index" :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox>
						</div>
					</template>

					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + (pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(controlcardnumber)="row">
						<a @click="() => ($router.push({ name: 'controlcarddetail', params: { id: row.item.id } }))"
							class="a-link-detail">
							{{ row.item.controlCardNumber != null && row.item.controlCardNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.controlCardNumber.slice(0, 30) + (row.item.controlCardNumber.length > 30 ? "..." : "")
									: row.item.controlCardNumber : "" }}
						</a>
					</template>

					<template v-slot:cell(controlCardType)="row">
						{{ row.item.controlCardType != null ? row.item.controlCardType.code : "" }}
					</template>
					<template v-slot:cell(part)="row">
						{{ row.item.part != null ? row.item.part.partNumber : "" }}
					</template>
					<template v-slot:cell(partClassification)="row">
						{{ row.item.part != null ? row.item.part.partClassification != null ? row.item.part.partClassification.code : "" : "" }}
					</template>
					<template v-slot:cell(area)="row">
						{{ row.item.area != null ? row.item.area.code : "" }}
					</template>
					<template v-slot:cell(rack)="row">
						{{ row.item.rack != null ? row.item.rack.code : "" }}
					</template>
					<template v-slot:cell(vendorSubcont)="row">
						{{ row.item.vendorSubcont != null ? row.item.vendorSubcont.name : "" }}
					</template>
					<template v-slot:cell(receivingDate)="row">
						{{ row.item.receivingDate | moment("DD-MMM-YYYY HH:mm") }}
					</template>
					<template v-slot:cell(deliveryDate)="row">
						{{ row.item.deliveryDate | moment("DD-MMM-YYYY HH:mm") }}
					</template>
					<template v-slot:cell(controlCardStatus)="row">
						{{ row.item.controlCardStatus != null ? row.item.controlCardStatus.name : "" }}
					</template>
					<template v-slot:cell(qcStatus)="row">
						{{ row.item.qcStatus != null ? row.item.qcStatus.name : "" }}
					</template>
					<template v-slot:cell(originalControlCard)="row">
						{{ row.item.originalControlCard != null ? row.item.originalControlCard.controlCardNumber : "" }}
					</template>
					<template v-slot:cell(createdDate)="row">
						{{ row.item.createdDate | moment("DD-MMM-YYYY HH:mm") }}
					</template>
					<template v-slot:cell(front-action)="row">
						<b-overlay
						:show="isBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
							<b-button @click="printCard(row.item.id)" size="sm" class="float-right btn-outline-success">
								Print Card 
							</b-button>
						</b-overlay>
						
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
							<app-input-combobox optionsLabel="partNumber" label-cols-sm="12" :model="row.item.partId"
								label="Part" :selected="row.item.part != null ? row.item.part.partNumber : ''"
								:isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-qty-case" label-cols-lg="12" label="Qty Case"
								label-for="input-qty-case" size="sm" :model.sync="row.item.qtyCase" :isEditable="false"
								:isUpdatable="true" />
							<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.areaId" label="Area"
								:selected="row.item.area != null ? row.item.area.code : ''" :isEditable="false"
								:isUpdatable="true" />
							<app-input-combobox optionsLabel="code" label-cols-sm="12" :model="row.item.rackId" label="Rack"
								:selected="row.item.rack != null ? row.item.rack.code : ''" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textbox id="fieldset-doc-no" label-cols-lg="12" label="DocNo"
								label-for="input-doc-no" size="sm" :model.sync="row.item.docNo" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textbox id="fieldset-status" label-cols-lg="12" label="Status"
								label-for="input-status" size="sm" :model.sync="row.item.status" :isEditable="false"
								:isUpdatable="true" />
							<app-input-datetimepicker id="fieldset-receiving-date" label-cols-lg="12" label="Receiving Date"
								size="sm" :model.sync="row.item.receivingDate"
								:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
								:isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-transaction-type" label-cols-lg="12" label="Transaction Type"
								label-for="input-transaction-type" size="sm" :model.sync="row.item.transactionType"
								:isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-transaction-id" label-cols-lg="12" label="Transaction Id"
								label-for="input-transaction-id" size="sm" :model.sync="row.item.transactionId"
								:isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-revisi" label-cols-lg="12" label="Revisi"
								label-for="input-revisi" size="sm" :model.sync="row.item.revisi" :isEditable="false"
								:isUpdatable="true" />
							<app-input-textbox id="fieldset-pack-sequence" label-cols-lg="12" label="Pack Sequence"
								label-for="input-pack-sequence" size="sm" :model.sync="row.item.packSequence"
								:isEditable="false" :isUpdatable="true" />
							<app-input-textbox id="fieldset-total-pack" label-cols-lg="12" label="Total Pack"
								label-for="input-total-pack" size="sm" :model.sync="row.item.totalPack" :isEditable="false"
								:isUpdatable="true" />
							<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.controlCardStatusId"
								label="Control Card Status"
								:selected="row.item.controlCardStatus != null ? row.item.controlCardStatus.name : ''"
								:isEditable="false" :isUpdatable="true" />
							<app-input-combobox optionsLabel="name" label-cols-sm="12" :model="row.item.qcStatusId" 
								label="Qc Status" 
								:selected="row.item.qcStatus != null ? row.item.qcStatus.name : ''" 
								:isEditable="false" :isUpdatable="true" />
							<app-input-combobox optionsLabel="controlCardNumber" label-cols-sm="12" :model="row.item.originalControlCardId" 
								label="Control Card Number" 
								:selected="row.item.originalControlCard != null ? row.item.originalControlCardId.controlCardNumber : ''" 
								:isEditable="false" :isUpdatable="true" />


						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size" v-model="currentPage"
									:total-rows="(controlCardsPaging != null ? controlCardsPaging.dataCount : 0)"
									:per-page="(controlCardsPaging != null ? controlCardsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right"
										:options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size"
										size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value"
											@click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
		<Upload :openPopup="showPopupUpload" @resetMethod="resetModalUpload" @uploadButtonMethod="uploadData" />
		<PopupDownload :openPopup="showPopupDownload" :processId="processId" @resetModalMethod="resetModal"
			label="Popup Download" :contentLabel="popupDownloadLabel" />
		<PopupPDF :openPopup="isShowPopupPDF" :pdfUrl="pdfUrl" @resetModalMethod="resetModal" label="Popup PDF" />
		<PopupDataEditNotification entityName="approvalconfiguration" :dataId="currentDataId" @resetModalMethod="resetModal"
			label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/index-page.scss';

::v-deep #table-list-controlcard.b-table.b-table-stacked>tbody>tr>td.th-front-action::before {
	background-image: url(/img/box-checklist.png);
	background-size: 40px 40px;
	display: block;
	width: 40px;
	height: 40px;
	content: "";
	margin-bottom: 10px;
}
::v-deep #table-list-controlcard.b-table>thead>tr>th {
	background: #e28b29;
}
::v-deep #table-list-controlcard.b-table.b-table-stacked>tbody>tr>td.th-front-action>div {
	display: flex;
}
</style>
<script>
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardList from '@/models/ControlCard/ControlCardList';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import ControlCardTypeFilter from '@/filters/ControlCardType/ControlCardTypeFilter';
import ControlCardType from '@/models/ControlCardType/ControlCardType';
import PartFilter from '@/filters/Part/PartFilter';
import Part from '@/models/Part/Part';
import AreaFilter from '@/filters/Area/AreaFilter';
import Area from '@/models/Area/Area';
import RackFilter from '@/filters/Rack/RackFilter';
import Rack from '@/models/Rack/Rack';
import PartClassificationFilter from '@/filters/PartClassification/PartClassificationFilter';
import PartClassification from '@/models/PartClassification/PartClassification';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import Vendor from '@/models/Vendor/Vendor';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import QcStatusFilter from '@/filters/QcStatus/QcStatusFilter';
import QcStatus from '@/models/QcStatus/QcStatus';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';

export default {
	components: {
		ControlCard,
		ControlCardList,
		ControlCardFilter,
		AppInputTextbox,
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
	},
	data() {
		return {
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData: 0,
			fields: [
				{ "checkboxAction": { "class": "th-front-action", "label": "" }},
				{ "front-action": { "class": "th-front-action", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "controlCardNumber": {}, "class": "th-control-card-number first-child", "label": "Control Card Number", key: 'controlCardNumber', sortable: true },
				{ "controlCardType": {}, "class": "th-control-card-type", "label": "Control Card Type", key: 'controlCardType', sortable: true },
				{ "part": {}, "class": "th-part last-child", "label": "Part", key: 'part', sortable: true },
				{ "partClassification": {}, "class": "th-part d-stack-none", "label": "Part Classification", key: "partClassification", sortable: true},
				{ "qtyCase": {}, "class": "th-qty-case d-stack-none", "label": "Qty Case", key: 'qtyCase', sortable: true },
				{ "area": {}, "class": "th-area d-stack-none", "label": "Area", key: 'area', sortable: true },
				{ "rack": {}, "class": "th-rack d-stack-none", "label": "Rack", key: 'rack', sortable: true },
				{ "vendorSubcont": {}, "class": "th-vendor-subcont d-stack-none", "label": "Vendor", key: 'vendorSubcont', sortable: true},
				//{ "docNo": {}, "class": "th-doc-no d-stack-none", "label": "DocNo", key: 'docNo', sortable: true },
				{ "status": {}, "class": "th-status d-stack-none", "label": "Status", key: 'status', sortable: true },
				{ "receivingDate": {}, "class": "th-receiving-date d-stack-none", "label": "Receiving Date", key: 'receivingDate', sortable: true },
				{ "deliveryDate": {}, "class": "th-delivery-date d-stack-none", "label": "Delivery Date", key: 'deliveryDate', sortable: true},
				{ "transactionType": {}, "class": "th-transaction-type d-stack-none", "label": "Transaction Type", key: 'transactionType', sortable: true },
				{ "transactionId": {}, "class": "th-transaction-id d-stack-none", "label": "Transaction Id", key: 'transactionId', sortable: true },
				{ "revisi": {}, "class": "th-revisi d-stack-none", "label": "Revisi", key: 'revisi', sortable: true },
				{ "packSequence": {}, "class": "th-pack-sequence d-stack-none", "label": "Pack Sequence", key: 'packSequence', sortable: true },
				{ "totalPack": {}, "class": "th-total-pack d-stack-none", "label": "Total Pack", key: 'totalPack', sortable: true },
				{ "controlCardStatus": {}, "class": "th-control-card-status d-stack-none", "label": "Control Card Status", key: 'controlCardStatus', sortable: true },
				{"qcStatus": {}, "class" : "th-qc-status d-stack-none", "label" : "Qc Status", key: 'qcStatus', sortable: true}, 
				{"originalControlCard": {}, "class" : "th-original-control-card d-stack-none", "label" : "Original Control Card", key: 'originalControlCard', sortable: true}, 
				{ "createdDate": {}, "class": "th-created-date d-stack-none", "label": "Created Date", key: 'createdDate', sortable: true },

				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			yesNoCombo: [
				{ id: 'TRUE', name: 'True', selected: true },
				{ id: 'FALSE', name: 'False' },
			],
			busy: false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			controlCards: [],
			controlCardsPaging: {},
			controlCardTypes: [],
			parts: [],
			areas: [],
			racks: [],
			controlCardStatuss: [],
			qcStatuss : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
			originalControlCardNumbers: [],
			vendors: [],
			partClassifications: [],
			checkAll: false,
			isBusy: false,
		}
	}, methods: {
		toggleSelectAll() {
			this.checkAll = !this.checkAll;
			if(this.checkAll) {
				if(this.controlCards.length == 0) return;

				this.controlCards.forEach(item => {
					console.log(item.id);
					if(!this.checkAllData.includes(Number(item.id))) {
						this.$store.dispatch("addCheckData", Number(item.id));
					}
				});
			} else {
				if(this.controlCards.length == 0) return;

				this.controlCards.forEach(item => {
					console.log(item.id);
					this.$store.dispatch("removeCheckData", Number(item.id))
				});
			}
		},
		createData() {
			this.isCreateBusy = true;
			ControlCard.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'controlcardedit';

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		async printCard(controlCardId){
			this.isBusy = true;
			let this_ = this;
			// console.log('controlCardId',controlCardId)
			if(controlCardId > 0) {
				this.$store.dispatch("removeCheckAllData")
				this.checkAllData.push(Number(controlCardId));
			}

			console.log("checkAllData", this.checkAllData);

			try {
				const result = await ControlCard.printControlCard(this_, this.checkAllData);
				if(result && result.data) {
					this.isBusy = false;	
				}
				
			} catch {
				this.isBusy = false;
			} finally {
				this.isBusy = false;
				this.$store.dispatch("removeCheckAllData");
			}
		},
		getControlCards: async function () {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ControlCard.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.controlCards = result.data
						console.log("data", this.controlCards);
						this.controlCardsPaging = result
					}
					this.isDataLoading = false;
				})
				.catch(error => {
					this.isDataLoading = false;
				});
		},
		getControlCardsWithoutLoading: async function () {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			ControlCard.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
				.then(result => {
					if (result != null) {
						this.controlCards = result.data
						this.controlCardsPaging = result
					}
				})
				.catch(error => { });
		},
		getControlCardTypes: async function (input) {
			let filter = new ControlCardTypeFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if (this.filter.controlCardTypeId != undefined && input == '') {
				filter.id = this.filter.controlCardTypeId;
			}
			ControlCardType.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCardTypes = result.data
					}
				})
				.catch(error => { });
		},
		getPartClassifications: async function (input) {
			let filter = new PartClassificationFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if (this.filter.partClassificationId != undefined && input == '') {
				filter.id = this.filter.partClassificationId;
			}
			PartClassification.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.partClassifications = result.data
					}
				})
				.catch(error => { });
		},
		getVendors: async function (input) {
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.name = input;
			}
			if (this.filter.vendorId != undefined && input == '') {
				filter.id = this.filter.vendorId;
			}
			Vendor.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.vendors = result.data
					}
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			if (this.filter.partId != null && input == '') {
				filter.id = this.filter.partId;
			}
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
				})
				.catch(error => { });
		},
		getOriginalControlCards: async function (input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			if (this.filter.originalControlCardId != null && input == '') {
				filter.id = this.filter.originalControlCardId;
			}
			ControlCard.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.originalControlCardNumbers = result.data
					}
				})
				.catch(error => { });
		},
		getAreas: async function (input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if (this.filter.areaId != undefined && input == '') {
				filter.id = this.filter.areaId;
			}
			Area.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.areas = result.data
					}
				})
				.catch(error => { });
		},
		getRacks: async function (input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			if (this.filter.rackId != undefined && input == '') {
				filter.id = this.filter.rackId;
			}
			Rack.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.racks = result.data
					}
				})
				.catch(error => { });
		},
		getControlCardStatuss: async function (input) {
			let filter = new ControlCardStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			if (this.filter.controlCardStatusId != undefined && input == '') {
				filter.id = this.filter.controlCardStatusId;
			}
			ControlCardStatus.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCardStatuss = result.data
					}
				})
				.catch(error => { });
		},
		getQcStatuss : async function(input) {
			let filter = new QcStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			if (this.filter.qcStatusId != undefined && input == '') {
				filter.id = this.filter.qcStatusId;
			}
			QcStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.qcStatuss = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new ControlCardFilter();
			this.getControlCards();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getControlCards();
		},
		toggleSelect(id) {
			console.log("id on toggleSelect", id);
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}

			console.log("checkAllData", this.checkAllData);
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				ControlCard.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			ControlCard.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			console.log('this.filter', this.filter);
			ControlCard.downloadData(this, this.filter, this.sortingBy)
				.then(result => {
					console.log('result ', result);
					if (result) {
						this.showPopupDownloadData(result.id);
					}
					this.isDownloadDataBusy = false;
				})
				.catch(error => {
					this.isDownloadDataBusy = false;
				})
		},

		deleteData(id) {
			ControlCard.deleteData(this, id).then(result => {
				if (result) {
					this.getControlCards();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				ControlCard.deleteMultipleData(this).then(result => {
					this.getControlCards();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tableControlCardParent = document.getElementById('table-list-controlcard').parentNode;
			tableControlCardParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tableControlCardParent.scrollWidth - tableControlCardParent.offsetWidth) == Math.ceil(tableControlCardParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tableControlCardParent = document.getElementById('table-list-controlcard').parentNode;
			tableControlCardParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tableControlCardParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new ControlCardFilter();
		// this.getControlCardTypes()
		// this.getParts()
		// this.getAreas()
		// this.getRacks()
		// this.getControlCardStatuss()
		// this.getQcStatuss()
	},
	mounted() {
		let breadcrumb = [
			"Master Data",
			"Control Card"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getControlCards();
			this.getControlCardTypes();
			this.getParts();
			this.getAreas();
			this.getRacks();
			this.getVendors();
			this.getPartClassifications();
			this.getControlCardStatuss();
			this.getQcStatuss();
			this.getOriginalControlCards();
			window.addEventListener('resize', this.onResize);
		});
	}, watch: {
		sortBy: {
			handler: function () {
				this.getControlCards();
			}
		},
		sortDesc: {
			handler: function () {
				this.getControlCards();
			}
		},
		currentPage: {
			handler: function () {
				this.getControlCards();
			}
		},
		pageSizeOptions: {
			handler: function () {
				this.getControlCards();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				ControlCard.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "controlcardindex") {
					this.getControlCardsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "control_card").first();
		},
		isShowDeleteButton: function () {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}

			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton: function () {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	}, beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
